import React from 'react';
import {Route} from 'react-router';
import RepProfilePageContainer from '$pages/$rep-profile/RepProfilePageContainer';

/**
 * Rep dashboard is outside of dashv2 still so it's served here.
 *
 * isGoHomeIfNotRep is checked in RepProfilePageContainer to redirect users who shouldn't see this page to /.
 */
export const repProfileRoutes = (
  <>
    <Route path="metrics/profile" component={RepProfilePageContainer} />

    {/* deprecated*/}
    <Route path="dash" component={RepProfilePageContainer} isGoHomeIfNotRep />
    {/* deprecated*/}
    <Route path="stats" component={RepProfilePageContainer} isGoHomeIfNotRep />
  </>
);
